export default __webpack_public_path__ + "static/roboto-v20-latin-ext-regular-5cb5c8f08bb4e6cb64c3b5b6115bf498.woff2";